import React, { useContext, useEffect, useState } from 'react'


import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import PageUrlGuid from '../component/pageUrlGuid'
import Seperator from '../component/seperator'
import { isUserRegisterWebinar, studentNumber, webinar, webinarFiles, webinars, webinarVisit } from '../service/webinarsService'
import { checkIsCompleteInfo } from '../service/userService'
import { errorMessage, infoMessage, successMessage } from "../utils/toastMessage"
import { isEmptyUser } from "./../utils/isEmpty"
import Modal from '../component/modal/modal';
import ReactPlayer from 'react-player';
import moment from 'jalali-moment';
import { timerCountDown } from '../service/webinarsService';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { TypeAnimation } from 'react-type-animation';
//third party
import { useSelector, useDispatch } from 'react-redux'

const Webinar = () => {

    const user = useSelector((state) => state.user)


    SwiperCore.use([Autoplay])



    const navigate = useNavigate()

    const [getWebinar, setWebinar] = useState({})
    const [getIsUserRegistered, setIsUserRegistered] = useState(false)
    const [getTags, setTags] = useState([])
    const [getWebinars, setWebinars] = useState([])
    const [getStudentNumber, setStudentNumber] = useState([])
    const [getModal, setModal] = useState(false)
    const [getVideoAdd, setVideoAdd] = useState("")
    const [getWebinarFiles, setWebinarFiles] = useState([])
    const [getTimer, setTimer] = useState("")
    const slug = useParams().slug



    const handleGetWebinarss = async () => {
        const { status, data } = await webinars();
        if (status === 200) {
            setWebinars(data.data.filter(webinar => webinar.is_special == true));
        }
    }


    const handleGetWebinars = async (slug) => {
        try {
            const { status, data } = await webinar(slug);
            if (status === 200) {
                console.log(data.webinar);
                document.getElementById("description").innerHTML = data.webinar.description
                setWebinar(data.webinar)
                setTags(data.tags)
            }
        }
        catch (ex) {
            navigate("/notFound")
        }
    }


    const handleCopyToClipboard = (element) => {
        var el = document.querySelector(element).innerHTML
        navigator.clipboard.writeText(el);
        successMessage("لینک کپی شد")
    }

    const handleBuy = async () => {
        if (isEmptyUser(user.value)) {
            infoMessage("ابتدا وارد حساب کاربری خود شوید")
        }

        else {
            try {
                const { status, data } = await checkIsCompleteInfo(user.value.username);
                console.log(status);
                if (status === 200) {
                    navigate(`/registerWebinar/${getWebinar.slug}`)
                }

            }
            catch (ex) {
                infoMessage("ابتدا اطلاعات حساب کاربری خود را کامل کنید")
            }
        }
    }

    const handetCheckUserRegistered = async () => {

        try {
            const { status, data } = await isUserRegisterWebinar(user.value.username, slug);
            if (status === 200) {
                setIsUserRegistered(true)
            }
        }
        catch (ex) {
        }
    }


    const handetGetWebinarFiles = async () => {
        try {
            const { status, data } = await webinarFiles(slug);
            if (status === 200) {
                setWebinarFiles(data.webinarFiles)
            }

        }
        catch (ex) {
        }
    }



    const handlePlayVideo = (add) => {
        if (getIsUserRegistered) {
            setModal(true)
            setVideoAdd(add)
        }
        else {
            if (isEmptyUser(user.value)) {
                infoMessage("ابتدا وارد حساب کاربری خود شوید")
            }
            else {
                infoMessage("شما این وبینار را نخریده اید")
            }
        }
    }

    const handleDisableRightClick = (event) => {
        event.preventDefault()
    }




    const handleGetStudentNumber = async () => {
        try {
            const { status, data } = await studentNumber(slug);
            if (status === 200) {
                setStudentNumber(data.register)
            }
        }
        catch (ex) {
        }
    }


    useEffect(() => {
        handleGetWebinarss()
    })

    useEffect(() => {
        handleGetWebinars(slug)
        handetCheckUserRegistered()
        handetGetWebinarFiles()
        handleGetStudentNumber()

        const disableRightClick = (event) => handleDisableRightClick(event)
        document.addEventListener('contextmenu', disableRightClick);
        return (() => {
            document.removeEventListener('contextmenu', disableRightClick)
        })
    }, [user.value])


    // const timer = () => {
    //     // Set the date we're counting down to
    //     var countDownDate = new Date(moment.from(getTimer, 'fa', 'YYYY/MM/DD')["_d"]).getTime();

    //     // Update the count down every 1 second
    //     var x = setInterval(function () {

    //         // Get today's date and time
    //         var now = new Date().getTime();

    //         // Find the distance between now and the count down date
    //         var distance = countDownDate - now;

    //         // Time calculations for days, hours, minutes and seconds
    //         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //         var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //         var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //         var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    //         // Output the result in an element with id="demo"
    //         document.getElementById("demo").innerHTML = `${days}\t${hours}\t${minutes}\t${seconds}`

    //         // If the count down is over, write some text 
    //         if (distance < 0) {
    //             clearInterval(x);
    //             document.getElementById("demo").innerHTML = "مهلت تخفیف تمام شد";
    //         }
    //     }, 1000);
    // }

    // const handleTimer = async () => {
    //     try {
    //         const { status, data } = await timerCountDown();
    //         if (status === 200) {
    //             setTimer(data.time)
    //         }
    //     }
    //     catch (ex) {
    //     }

    // }
    // useEffect(()=>{
    //     handleTimer()
    // })

    // useEffect(() => {
    //     timer()
    // },[getTimer])

    return (
        <>
            <Helmet>
                <title>{`${getWebinar.title} | نیو وبینار`}</title>
            </Helmet>
            {
                getModal
                    ?
                    <Modal stateName={setModal}>
                        {/* <video width="80%" height="auto" preload='true' controls controlsList="nodownload">
                            <source data-src={getVideoAdd} type="video/mp4" />
                        </video> */}
                        <ReactPlayer
                            // Disable download button
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}

                            // Disable right click
                            onContextMenu={e => e.preventDefault()}
                            url={getVideoAdd}
                            playing={true}
                            width="80%"
                            height="auto"
                            controls={true}
                            download={false}
                        />
                    </Modal>
                    : null
            }





            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <Link to={"/webinars"}>
                    وبینار ها
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getWebinar.title}
                </h1>
            </PageUrlGuid>

            {/* 
            <div className='spec'>
                <div className='timer_'>
                    <span className='title'> مهلت باقی مانده تا پایان تخفیف های ویژه  </span>
                    <pre id='demo' style={{ margin: "0px" }}></pre>
                    <span>ثانیه دقیقه ساعت روز</span>
                </div>
                <TypeAnimation
                    className='text-anim'
                    sequence={['دوره های ویژه', 1000, '']}
                    speed={75}
                    wrapper="h2"
                    cursor={false}
                    repeat={Infinity}
                />

            </div> */}


            {/* <Swiper
                modules={[FreeMode, Pagination, Navigation]}
                spaceBetween={5}
                slidesPerView={2}
                // loop={true}
                autoplay={{
                    delay: 4000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false
                }}
                className={"content"}
                breakpoints={
                    // when window width is <= 499px
                    {
                        600: {
                            slidesPerView: 3,
                            spaceBetweenSlides: 5
                        },
                        900: {
                            slidesPerView: 5,
                            spaceBetweenSlides: 5
                        }
                    }
                }
            >
                {getWebinars == undefined ? (null) : (
                    getWebinars.map(webinar => (
                        <SwiperSlide key={webinar.id} style={{ direction: "rtl" }}>
                            <a className='webinar' href={`/webinars/${webinar.slug}`}>
                                <img src={webinar.image} width={'100%'} height={'auto'} alt="" />
                                <span style={{ backgroundColor: "rgb(33, 49, 54)", display: "inline-block", color: "white", padding: "10px", borderRadius: "5px", height: "auto", width: "100%" }}>
                                    {webinar.title}
                                </span>
                            </a>
                        </SwiperSlide>
                    ))
                )}
            </Swiper> */}

            <div className='singleBlog'>
                <div className='information-container'>
                    {getWebinar.webinarType == "other" ? null : (
                        getIsUserRegistered ? (
                            <button className='buy' >شما در این وبینار ثبت نام کرده اید
                            </button>
                        ) : (
                            getWebinar.capacity - getStudentNumber <= 0 ? (
                                <button className='buy' style={{ backgroundColor: "red" }}>  ظرفیت وبینار تکمیل شد
                                    {/* <i className='fa fa-check'></i> */}
                                </button>
                            ) : (
                                <button className='buy' onClick={handleBuy}>ثبت نام در این وبینار
                                    (ظرفیت باقی مانده :{getWebinar.capacity - getStudentNumber})
                                    <i className='fa fa-check'></i>
                                </button>
                            )

                        ))}
                </div>
                <div className='content-container'>
                    <div className='content'>
                        <img src={getWebinar.image} alt={getWebinar.title} />
                        <h2 className='title'>{getWebinar.title}</h2>
                        <h3 className='briefing'>{getWebinar.brifing}</h3>
                        <div className='description' id='description'></div>
                    </div>




                    <div className='tags'>
                        <div className='title'>
                            <i className='fa fa-tags'></i>
                            <h2>برچسب ها</h2>
                        </div>
                        <div className='tags-content'>
                            {getTags.map(tag => (
                                <Link to={`/webinars?page=1&filter=id&search=${tag.title}&category=`} key={tag.id} className='tag'>{tag.title}</Link>
                            ))}
                        </div>
                    </div>
                    <div className='social-shortcut'>
                        <div className='social'>
                            <span className='title'>اشتراک گذاری :</span>
                            <div className='icons'>
                                <a className='link' href={`whatsapp://send?text=${window.location.href}`}>
                                    <img className='whatsapp-icon' src={`https://dl.newwebinar.ir/base/whatsapp.png`} alt="" />
                                </a>
                                <a className='link' href={`https://t.me/share/url?url=${window.location.href}`}>
                                    <img className='telegram-icon' src={`https://dl.newwebinar.ir/base/whatsapp.png`} alt="" />
                                </a>
                            </div>
                        </div>
                        <div className='shortcut' onClick={() => handleCopyToClipboard("#short-link")}>
                            <span>لینک کوتاه :</span>
                            <span className='short-link' id={'short-link'}>{`https://www.newwebinar.ir/s/1${getWebinar.id}`}</span>
                            <i className='fas fa-copy' ></i>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Webinar